module.exports = __webpack_public_path__ + "img/user.50654a58.png";